const organizationReducer = (state = {}, action) => {
    switch (action.type) {
        case 'STORE_ORGANIZATION_INFO':
            return action.payload;
        default:
            return state;
    }
};
export default organizationReducer;